<div class="flex flex-col w-full h-full p-6 gap-6 bg-surface-50 overflow-auto">
    <div class="flex w-full gap-6 items-center px-7">
      <div class="justify-start text-surface-900 text-2xl font-semibold font-['Inter'] leading-8">
        {{ 'Viewing ' + (this.store.taSubmission()?.taNumber ?? 'TA') }}
      </div>
      <p-chip [label]="toTAStatusText(status() ?? '')"/>
      <div class="flex-1"></div>
      @if (!isFlightOnly()) {
        <ta-cost-bubble [title]="isAcquitted() ? 'Acquitted TA Value' : status() === 'PendingAcquittal' ? 'Pending Acquittal TA Value' : isApproved() ? 'Approved TA Value' : 'Total TA Value'" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
      }
    </div>
  <view-ta [edit]="false"></view-ta>
</div>
